<template>
    <div role="group" class="form-group mb-0">
        <label class="col-form-label pt-0">
            {{ label }}
        </label>
        <small v-if="_.get(config, 'description')" class="form-text mb-2">{{ _.get(config, 'description', '') }}</small>
        <lazy-loading-select-component
            v-if="initialized"
            v-model="selectedPage"
            v-on:change="onSelect"
            :required="required"
            :config="selectConfig"
            ></lazy-loading-select-component>
        <label class="col-form-label pt-0">
            Redirect to this page
        </label>
        <input v-on:input="onInput"
            type="text"
            class="form-control mb-2"
            placeholder="Make sure to include 'http://' if linking to an external URL"
            :value="value">
    </div>
</template>
<script>
import Vue from 'vue';
import LazyLoadingSelectComponent from '../form-elements/LazyLoadingSelectComponent';

export default {
    data () {
        return {
            initialized: true,
            selectedPage: null,
            currentValue: '',
            values: [],
        }
    },

    props: ['value', 'label', 'required', 'config', 'state', 'error'],

    components: {
        LazyLoadingSelectComponent,
    },

    computed: {
        selectConfig() {
            return { ...this.config, description: '' }
        },
    },

    methods: {
        onSelect(page) {
            let path = _.get(page, 'path', '');
            if (!path.match(/^#/)) {
                path = '/' + path;
            }

            this.$emit('input', path);
            this.$emit('change', path);
        },

        onInput(e) {
            const value = e.target.value;
            this.$emit('input', value);
            this.$emit('change', value);
        },
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/form-elements/UrlSelectComponent.vue